import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, SelectInput, EMPTY_ARRAY, NumberInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { onChangeOfferValueAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	bucketName: yup.string().required('Bucket Name is a required field'),
	isActive: yup.boolean(),
	absorptionAmountLimit: yup.number(),
	absorptionTransactionLimit: yup.number()
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	isActive: yup.boolean(),
	bucketName: yup.string(),
	absorptionAmountLimit: yup.number(),
	absorptionTransactionLimit: yup.number()
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	IS_ACTIVE: 'isActive',
	BUCKET_NAME: 'bucketName',
	ABSORPTION_AMOUNT_LIMIT: 'absorptionAmountLimit',
	ABSORPTION_TRANSACTION_LIMIT: 'absorptionTransactionLimit',
	SEGMENT_TYPE: 'segmentType',
	FORM: 'form'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.ABSORPTION_AMOUNT_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.ABSORPTION_TRANSACTION_LIMIT)])
	])
];

export const EDIT_TDS_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.ABSORPTION_AMOUNT_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.ABSORPTION_TRANSACTION_LIMIT)])
	])
];

export const sampleData: { [key: string]: string }[] = [
	{ id: 'test', label: 'TEST' },
	{ id: 'control', label: 'CONTROL' }
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: sampleData,
			required: true
		})
		.setToolTip('TDS Segment Name'),
	[FORM_FIELD_KEYS.BUCKET_NAME]: new RenderConfig()
		.setName('bucketName')
		.setLabel('Bucket Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: sampleData,
			required: true
		})
		.setToolTip('TDS Absorption Bucket Name'),
	[FORM_FIELD_KEYS.IS_ACTIVE]: new RenderConfig()
		.setName('isActive')
		.setLabel('Is Offer Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('Is offer active or not'),
	[FORM_FIELD_KEYS.ABSORPTION_AMOUNT_LIMIT]: new RenderConfig()
		.setName('absorptionAmountLimit')
		.setLabel('Absorption Amount Limit')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			onChangeCallback: onChangeOfferValueAction,
			required: false
		})
		.setToolTip('Absorption Amount Limit'),
	[FORM_FIELD_KEYS.ABSORPTION_TRANSACTION_LIMIT]: new RenderConfig()
		.setName('absorptionTransactionLimit')
		.setLabel('Absorption Transaction Limit')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			onChangeCallback: onChangeOfferValueAction,
			required: false
		})
		.setToolTip('Absorption Transaction Limit')
};

const userSegementType: { [key: string]: string } = { id: 'user', label: 'USER' };
const liveSegementType: { [key: string]: string } = { id: 'live', label: 'LIVE' };

export const validationSchemaActivateOffer = yup.object().shape({
	segmentType: yup.string().required('Segment Type is a required field')
});

export const ACTIVATE_OFFER_FORM_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_TYPE]: new RenderConfig()
		.setName('segmentType')
		.setLabel('Move Segment To.')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [liveSegementType, userSegementType],
			required: true
		})
		.setToolTip('TDS Absorption segment type')
};

export const ACTIVATE_OFFER_LAYOUT = [new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.SEGMENT_TYPE)])])];

export const TDS_OFFER_UPDATE_CONFIG = {
	...FORM_FIELD_CONFIG,
	[FORM_FIELD_KEYS.FORM]: new RenderConfig()
		.setName('form')
		.setLabel('Offer form')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true
		})
};

export const getFormDefaults = (segmentList: any) => {
	return {
		segmentName: segmentList,
		isActive: false,
		bucketName: '',
		absorptionAmountLimit: 0,
		absorptionTransactionLimit: 0
	};
};

export const getActivateOfferFormDefaults = () => {
	return {
		segmentType: 'control'
	};
};
